var resources = require('itemsViewStrings');
    var strings = resources['_jZ+R6jroeyYGy7jBOsNdOA'];
export { strings };
export default strings;
